import type { ItemType, MenuSectionValueType } from '../types/lib/types';
import type { TileUrlInfo, UrlsDataType } from '../types/lib/useGetTileUrls';
import { useAtomValue, useSetAtom } from 'jotai';
import { menuItemsAtom, menuAtom, tileDatasAtom } from '../atoms';
import { fiwareDataItemType } from '../types';

export const useGetTileUrls = () => {

  const menu = useAtomValue(menuAtom);
  const setTileDatas = useSetAtom(tileDatasAtom);         // mapに追加するtileをセットするやつ

  if (!menu) { return []; }

  const result: TileUrlInfo[] = [];

  Object.keys(menu).forEach((key) => {
    if (!menu[key] || !menu[key].metadata) { return; }
    const metadata = menu[key].metadata;
    if ('tileUrl' in metadata && metadata.tileUrl !== '' && 'dataName' in metadata) {
      result.push({
        id: metadata.dataName,
        tileUrl: typeof metadata.tileUrl === 'string' ? metadata.tileUrl : JSON.stringify(metadata.tileUrl)
      } as TileUrlInfo);
    }
  });

  setTileDatas(result);

  return result;
}


/**
 * メニューセクションを引数に取り、指定された dataType のリストを取得する関数
 * @param menuSection 
 * @param dataType 
 * @returns  { tileId: string; tileUrl: string }[]
 */
export const getDataUrlsByType = (menuSection: MenuSectionValueType | undefined, dataType: string) => {
  if (!menuSection) {
    return [];
  }

  function* extractData(menuItem: ItemType): Generator<UrlsDataType> {
    // 指定された dataType の場合、tileIdとtileUrlを返す
    if (
      'tileId' in menuItem &&
      'metadata' in menuItem &&
      menuItem.metadata?.dataType === dataType &&
      menuItem.tileId &&
      menuItem.metadata?.tileUrl
    ) {
      const tileId = menuItem.dataType === 'fiware' ? (menuItem as unknown as fiwareDataItemType).dataId : menuItem.tileId;
      const result: UrlsDataType = { name: menuItem.name, tileId: tileId, tileUrl: menuItem.metadata.tileUrl};
      // legendTypeがあれば追加
      if (menuItem.metadata.legendType) {
        result['legendType'] = menuItem.metadata.legendType;
      }
      yield result;
    }

    // カテゴリの場合、itemsを再帰的に処理
    if ('items' in menuItem && menuItem.items) {
      for (const item of Object.values(menuItem.items)) {
        yield* extractData(item); // ネストされたデータも再帰的に処理
      }
    }
  }

  const result = [];
  for (const section of Object.values(menuSection)) {
    for (const item of extractData(section as unknown as ItemType)) {
      result.push(item);
    }
  }

  return result;
};

/**
 * 指定された dataType のリストを取得するカスタムフック（Atom を使っているので menuSectionの引数不要）
 * @param dataType 
 * @returns  { tileId: string; tileUrl: string }[]
 */
export const useGetTileUrlsByType = (dataType: string) => {
  const menuSection = useAtomValue(menuItemsAtom) as MenuSectionValueType | undefined;
  return getDataUrlsByType(menuSection, dataType);
};
